import React, { useEffect } from "react";
import Routes from "./config/Routes/index";
import { AuthProvider } from "context/AuthContext";
import { QueryClient, QueryClientProvider } from "react-query";
import { SnackbarProvider } from "context/SnackbarContext";
import { CloseLeadContactProvider } from "context/CloseLeadContext";
import { DeepLinkMeetingProvider } from "context/DeepLinkMeetingContext";
import { HelmetProvider } from "react-helmet-async";

function App() {
  const queryClient = new QueryClient();

  // SessionStorage Transfer Listener for New Tabs
  // This allows new tabs to receive sessionStorage from parent window
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) {
        // console.log("Message rejected - wrong origin:", event.origin);
        return;
      }

      if (event.data?.type === "SESSION_STORAGE_TRANSFER") {
        // console.log(
        //   "✅ Received sessionStorage from parent window",
        //   event.data.data,
        // );

        Object.entries(event.data.data).forEach(([key, value]) => {
          sessionStorage.setItem(key, value);
        });

        // Store isOrganiser flag if passed from parent window
        if (event.data.isOrganiser !== undefined) {
          sessionStorage.setItem("isOrganiser", JSON.stringify(event.data.isOrganiser));
        }

        // console.log("✅ SessionStorage restored, reloading page...");

        window.location.reload();
      }
    };

    window.addEventListener("message", handleMessage);

    if (window.opener) {
      // console.log("🔔 Child window ready, signaling to parent...");
      window.opener.postMessage(
        { type: "CHILD_READY" },
        window.location.origin,
      );
    }

    // Cleanup listener on unmount
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <SnackbarProvider>
            <CloseLeadContactProvider>
              <DeepLinkMeetingProvider>
                <Routes />
              </DeepLinkMeetingProvider>
            </CloseLeadContactProvider>
          </SnackbarProvider>
        </AuthProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
